// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-set-groups__container ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    /* position: relative; */
}

.tournament-set-groups__container__title{
    padding: 0px 8px 16px 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tournament-set-groups__group_name{
    margin-top: var(--space);
    margin-bottom: var(--space);
    margin-left: calc( var(--space-and-half) + 2px );
    display: flex;
    align-items: center;
    white-space: nowrap;
}

.tournament-set-groups__container{
    grid-area: right;
    padding-bottom: var(--space-and-half); 
    padding: var(--space-half-quarter);
    background: var(--white-color);
    border-radius: 8px;
    margin-left: 12px;
}

.tournament-set-groups__container.groups-all-screen{
    grid-column-start: 1;
    grid-column-end: 13;

    
}

.tournament-set-groups__add-button {
    color: var(--secondary-color);
    padding: 0px;
    height: var(--space-and-half);
    width: calc(var(--space) * 5);
    margin-top: var(--space);
    margin-bottom: var(--space);
    margin-right: var(--space-half-quarter);
    margin-left: auto;
    display: block;
}

.tournament-set-groups__delete-button .icon-x {
    border: 3px solid var( --new-gray-color );
    border-radius: 50%;
    color: var( --new-gray-color );
    font-weight: 800;
    padding: 3px;
}

.tournament-set-groups__delete-button {
    color: var(--primary-dark-color);
    padding: 0px;
    height: var(--space-and-half);
    margin-top: var(--space);
    margin-bottom: var(--space);    
    display: block;
}

/* .tournament-set-groups__list {
    overflow: auto;
    max-height: calc( calc(var(--space-x3) + var(--space-half)) * 10);
} */

.tournament-set-groups__list-item {
    /* border-top: 1px solid transparent;
    border-right: 1px solid transparent; */
    border-bottom: 1px solid var(--primary-light-color);    
    /* border-left: 1px solid transparent;
    margin-left: var(--space-half-quarter);
    margin-right: var(--space-half-quarter); */
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 20px ;
    position: relative;
    padding: var(--space-half);
    
}

/* .tournament-set-groups__list-item {
    z-index: 1;
    background-color: aquamarine;
} */

.tournament-set-groups__list-item__img{
    width: 40px;
    height: 40px;
    /* float: left; */
    /* margin-top: var(--space);
    margin-bottom: var(--space);
    margin-right: var(--space-half);
    margin-left: var(--space-half);
    font-size: var(--space-and-half); */
    border-radius: 50%;
}

.tournament-set-groups__list-item .icon-ball{
    color: var( --white-color );
    font-size: 30px;
    border-radius: 50%;
    padding: 5px; 
}

.tournament-set-groups__list-item__img__empty{
    width: var(--space-and-half);
    height: var(--space-and-half);
    float: left;
    margin-top: var(--space);
    margin-bottom: var(--space);
    margin-right: var(--space-half);
    margin-left: var(--space-half);
    font-size: var(--space-and-half);
    color: var(--mid-gray-color);
}

.tournament-set-groups__list-item__empty{
    display:grid;
    justify-content:center;
    padding: var(--space-x2);
}

.tournament-set-groups__list-item__empty .baloa-normal-medium{
    color: var(--basic-gray-color);
}


.tournament-set-groups__list-item__text{
    margin-left: var(--space-half);
}

.tournament-set-groups__list-item__text__empty{
    float: left;
    margin-top: var(--space);
    margin-bottom: var(--space);
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc( var(--space) - 2px );
    line-height: var(--space-and-half);
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var(--mid-gray-color);
}

.tournament-set-groups__list__button {
    display: flex;
    justify-content: flex-end;   
    margin-top: var(--space-half);; 
}


.tournament-set-groups__container__title .tournament-set-groups__container__btn:first-of-type {
    margin-right: var(--space-half);
}

.tournament-set-groups__container__title .button span {
    grid-area: unset;
    margin-right: var(--space-half-quarter);
}

.tournament-set-groups__container__title .baloa-normal-medium {
    color: var(--basic-gray-color);
}

.tournament-set-groups__container__title .baloa-subtitle-1{
    color: var(--primary-very-dark-color);
}

.tournament-set-groups__container__buttons {
    display: flex;    
}

.tournament-set-groups__info-item {
    display: flex;
    align-items: center;    
}

.tournament-set-groups__info-item .baloa-names,
.tournament-set-groups__info-item .baloa-username {
    color: var(--primary-dark-color);
}

.tournament-set-groups_item_box{
    background: var(--white-color);
    margin: var(--space-half) 0;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);
    border-radius: 9px;
}

.tournament-set-groups_item_box_text_switch{
    background: var(--new-light-gray-background-color);
    border-bottom: 1px solid var(--new-gray-background-color);
    border-radius: 9px 9px 0px 0px;
}

/* .tournament-set-groups-phases-information_options-box.active {
    display: flex;
    flex-direction: column;
    gap: var(--space-half);
} */

/* .tournament-set-groups-phases-information_options-box{
    position: absolute;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgb(150 150 150 / 25%);
    width: 160px;
    right: 50px;
    display: none;
    border-radius: 8px;
    border: 1px solid #E7E7E7;
    padding: var(--space-half);
} */

.tournament-set-groups__list-item .icon-options{
    padding: var(--space-and-half);
}

.tournament-set-groups__list-item .icon-options:hover{
    cursor: pointer;
}

/* .tournament-set-groups-phases-information_options-team-box.active {
    display: flex;
    flex-direction: column;
} */

/* .tournament-set-groups-phases-information_options-team-box{
    position: absolute;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgb(150 150 150 / 25%);
    width: 283px;
    right: 39px;
    height: 30%;
    display: none;
    border-radius: 8px;
    border: 1px solid #E7E7E7;
    padding: var(--space-half);
    top: 38px;
} */

.tournament-players-information_options-box_cancel_team{
    display: flex;
    justify-content: space-between;
    align-items: baseline;
}

/* .tournament-players-information_options_group{
    position: absolute;
    top: 10%;
    left: 100%;
    z-index: 0;
} */


/* .tournament-set-groups__actions-group,
.tournament-set-groups__options-team {
    display: none;
} */

.tournament-set-groups__groups{
    background-color: var(--new-background-color);
    padding: 12px;
}

.tournament-set-groups__group_information{
    display: flex;
    align-items: center;
    gap: var(--space);
    justify-content: space-between;
}

.tournament-set-groups__group_information .hubicon-delete{
    font-size: var(--space-x2);
    margin-right: var(--space);
}

.tournament-set-groups__group_information .hubicon-delete:hover{
    cursor: pointer;
}

.tournament-set-groups__group_information .icon-options{
    font-size: var(--space-and-half);
    margin-right: var(--space);
}

.tournament-players-information_options-box_button_addPhase{
    display: flex;
    gap: var(--space)
}

.tournament-set-groups__list-item._disabled{
    padding: var(--space-half);    
}

.tournament-set-free-number_increase-decrease{
    display: flex;
    align-items: flex-end;
    gap: var(--space);
    margin-bottom: var(--space-half);
}

.tournament-set-groups-number_increase-decrease{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: var(--space-half);
}

.tournament-set-groups-number_increase-decrease-text.baloa-names{
    color: var(--basic-gray-color);
    margin-bottom: var(--space-half);
    margin-left: var(--space-and-half);
}

.tournament-set-groups-number_increase-decrease-text.baloa-names .baloa-normal-medium{
    color: var(--primary-dark-color);
}

.tournament-set-groups_increase-decrease__value {
    display: flex;
    align-items: center;
    background-color: var( --new-background-color );
    padding: var( --space-eighth );
    border-radius: var( --space-quarter );
    width: 7rem;
    justify-content: space-between;
}

.tournament-set-groups_increase-decrease__value .btn {
    background-color: var( --new-green-color );
    color: var( --white-color );
    width: var( --space-x2 );
    height: var( --space-x2 );
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var( --space-quarter );
    cursor: pointer;
}

.tournament-set-groups_increase-decrease__value input {
    border: none;
    background-color: transparent;
    width: var(--space-x3);
    text-align: center;
}

.tournament-set-groups_increase-decrease__value input:focus {
    outline: none;    
}

.tournament-set-groups_increase-decrease__value input[type=number]::-webkit-inner-spin-button,
.tournament-set-groups_increase-decrease__value input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.tournament-set-groups__group-options {
    position: relative;
    z-index: 1;
}

.tournament-set-groups__container__title .tournament-set-groups__group-options {
    display: flex;
    justify-content: flex-end;
    width: 100%;
}

.tournament-set-groups__container__title .tournament-set-groups__group-options .tournament-set-groups__group-options__box-option {
    margin-bottom: 0;
}

.tournament-set-groups__container__title .tournament-set-groups__group-options__box {
    top: 0;
}

.tournament-set-groups__group-options .icon-options {
    cursor: pointer;
}

.tournament-set-groups__group-options__box {
    background-color: var(--white-color);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: var(--space-half);
    position: absolute;
    right: var(--space-and-half);
    top: var(--space-x2);
    padding: var(--space-half-quarter);
    display: none;
}

.tournament-set-groups__group-options__box.show {
    display: block;
}

.tournament-set-groups__group-options__box-option {
    display: flex;
    align-items: center;
    padding: calc( var(--space-half) + var(--space-eighth) ) var(--space-half-quarter);
    cursor: pointer;
}

.tournament-set-groups__group-options__box-option:hover {
    background: var(--new-background-color);
    border-radius: var(--space-quarter);
}

.tournament-set-groups__group-options__box-option .baloa-names {
    white-space: nowrap;
    margin-left: var(--space-half-quarter);
}

.tournament-set-groups__group-options__box-option .hubicon-edit,
.tournament-set-groups__group-options__box-option .hubicon-delete_question {
    font-size: var(--space-and-half);
}

.tournament-set-groups__group-options__box-option .hubicon-edit::before,
.tournament-set-groups__group-options__box-option .hubicon-delete_question::before {
    color: var(--primary-very-dark-color);
}

.tournament-set-groups__group_information .basic-data__form_edit_content__input_grid-tooltip {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-set-groups/TournamentSetGroupsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,gDAAgD;IAChD,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,kCAAkC;IAClC,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;;;AAGvB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,6BAA6B;IAC7B,6BAA6B;IAC7B,wBAAwB;IACxB,2BAA2B;IAC3B,uCAAuC;IACvC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,6BAA6B;IAC7B,wBAAwB;IACxB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;;;GAGG;;AAEH;IACI;0CACsC;IACtC,mDAAmD;IACnD;;8CAE0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,0BAA0B;;AAE9B;;AAEA;;;GAGG;;AAEH;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB;;;;uCAImC;IACnC,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,WAAW;IACX,wBAAwB;IACxB,2BAA2B;IAC3B,+BAA+B;IAC/B,8BAA8B;IAC9B,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,2BAA2B;IAC3B,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,qCAAqC;IACrC,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,6BAA6B;AACjC;;;AAGA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,kDAAkD;IAClD,yDAAyD;IACzD,8BAA8B;AAClC;;AAEA;;;;GAIG;;AAEH;;;;;;;;;;GAUG;;AAEH;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;;;GAGG;;AAEH;;;;;;;;;;;;GAYG;;AAEH;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;;;;;GAKG;;;AAGH;;;GAGG;;AAEH;IACI,6CAA6C;IAC7C,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,+CAA+C;IAC/C,8BAA8B;IAC9B,qCAAqC;IACrC,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;IAC3B,wBAAwB;IACxB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,2CAA2C;IAC3C,gCAAgC;IAChC,kBAAkB;IAClB,4BAA4B;IAC5B,oBAAoB;IACpB,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kFAAkF;IAClF,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,WAAW;AACf","sourcesContent":[".tournament-set-groups__container ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    /* position: relative; */\n}\n\n.tournament-set-groups__container__title{\n    padding: 0px 8px 16px 8px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.tournament-set-groups__group_name{\n    margin-top: var(--space);\n    margin-bottom: var(--space);\n    margin-left: calc( var(--space-and-half) + 2px );\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n}\n\n.tournament-set-groups__container{\n    grid-area: right;\n    padding-bottom: var(--space-and-half); \n    padding: var(--space-half-quarter);\n    background: var(--white-color);\n    border-radius: 8px;\n    margin-left: 12px;\n}\n\n.tournament-set-groups__container.groups-all-screen{\n    grid-column-start: 1;\n    grid-column-end: 13;\n\n    \n}\n\n.tournament-set-groups__add-button {\n    color: var(--secondary-color);\n    padding: 0px;\n    height: var(--space-and-half);\n    width: calc(var(--space) * 5);\n    margin-top: var(--space);\n    margin-bottom: var(--space);\n    margin-right: var(--space-half-quarter);\n    margin-left: auto;\n    display: block;\n}\n\n.tournament-set-groups__delete-button .icon-x {\n    border: 3px solid var( --new-gray-color );\n    border-radius: 50%;\n    color: var( --new-gray-color );\n    font-weight: 800;\n    padding: 3px;\n}\n\n.tournament-set-groups__delete-button {\n    color: var(--primary-dark-color);\n    padding: 0px;\n    height: var(--space-and-half);\n    margin-top: var(--space);\n    margin-bottom: var(--space);    \n    display: block;\n}\n\n/* .tournament-set-groups__list {\n    overflow: auto;\n    max-height: calc( calc(var(--space-x3) + var(--space-half)) * 10);\n} */\n\n.tournament-set-groups__list-item {\n    /* border-top: 1px solid transparent;\n    border-right: 1px solid transparent; */\n    border-bottom: 1px solid var(--primary-light-color);    \n    /* border-left: 1px solid transparent;\n    margin-left: var(--space-half-quarter);\n    margin-right: var(--space-half-quarter); */\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 0 20px ;\n    position: relative;\n    padding: var(--space-half);\n    \n}\n\n/* .tournament-set-groups__list-item {\n    z-index: 1;\n    background-color: aquamarine;\n} */\n\n.tournament-set-groups__list-item__img{\n    width: 40px;\n    height: 40px;\n    /* float: left; */\n    /* margin-top: var(--space);\n    margin-bottom: var(--space);\n    margin-right: var(--space-half);\n    margin-left: var(--space-half);\n    font-size: var(--space-and-half); */\n    border-radius: 50%;\n}\n\n.tournament-set-groups__list-item .icon-ball{\n    color: var( --white-color );\n    font-size: 30px;\n    border-radius: 50%;\n    padding: 5px; \n}\n\n.tournament-set-groups__list-item__img__empty{\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    float: left;\n    margin-top: var(--space);\n    margin-bottom: var(--space);\n    margin-right: var(--space-half);\n    margin-left: var(--space-half);\n    font-size: var(--space-and-half);\n    color: var(--mid-gray-color);\n}\n\n.tournament-set-groups__list-item__empty{\n    display:grid;\n    justify-content:center;\n    padding: var(--space-x2);\n}\n\n.tournament-set-groups__list-item__empty .baloa-normal-medium{\n    color: var(--basic-gray-color);\n}\n\n\n.tournament-set-groups__list-item__text{\n    margin-left: var(--space-half);\n}\n\n.tournament-set-groups__list-item__text__empty{\n    float: left;\n    margin-top: var(--space);\n    margin-bottom: var(--space);\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc( var(--space) - 2px );\n    line-height: var(--space-and-half);\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var(--mid-gray-color);\n}\n\n.tournament-set-groups__list__button {\n    display: flex;\n    justify-content: flex-end;   \n    margin-top: var(--space-half);; \n}\n\n\n.tournament-set-groups__container__title .tournament-set-groups__container__btn:first-of-type {\n    margin-right: var(--space-half);\n}\n\n.tournament-set-groups__container__title .button span {\n    grid-area: unset;\n    margin-right: var(--space-half-quarter);\n}\n\n.tournament-set-groups__container__title .baloa-normal-medium {\n    color: var(--basic-gray-color);\n}\n\n.tournament-set-groups__container__title .baloa-subtitle-1{\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-set-groups__container__buttons {\n    display: flex;    \n}\n\n.tournament-set-groups__info-item {\n    display: flex;\n    align-items: center;    \n}\n\n.tournament-set-groups__info-item .baloa-names,\n.tournament-set-groups__info-item .baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.tournament-set-groups_item_box{\n    background: var(--white-color);\n    margin: var(--space-half) 0;\n    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);\n    border-radius: 9px;\n}\n\n.tournament-set-groups_item_box_text_switch{\n    background: var(--new-light-gray-background-color);\n    border-bottom: 1px solid var(--new-gray-background-color);\n    border-radius: 9px 9px 0px 0px;\n}\n\n/* .tournament-set-groups-phases-information_options-box.active {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-half);\n} */\n\n/* .tournament-set-groups-phases-information_options-box{\n    position: absolute;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgb(150 150 150 / 25%);\n    width: 160px;\n    right: 50px;\n    display: none;\n    border-radius: 8px;\n    border: 1px solid #E7E7E7;\n    padding: var(--space-half);\n} */\n\n.tournament-set-groups__list-item .icon-options{\n    padding: var(--space-and-half);\n}\n\n.tournament-set-groups__list-item .icon-options:hover{\n    cursor: pointer;\n}\n\n/* .tournament-set-groups-phases-information_options-team-box.active {\n    display: flex;\n    flex-direction: column;\n} */\n\n/* .tournament-set-groups-phases-information_options-team-box{\n    position: absolute;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgb(150 150 150 / 25%);\n    width: 283px;\n    right: 39px;\n    height: 30%;\n    display: none;\n    border-radius: 8px;\n    border: 1px solid #E7E7E7;\n    padding: var(--space-half);\n    top: 38px;\n} */\n\n.tournament-players-information_options-box_cancel_team{\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n}\n\n/* .tournament-players-information_options_group{\n    position: absolute;\n    top: 10%;\n    left: 100%;\n    z-index: 0;\n} */\n\n\n/* .tournament-set-groups__actions-group,\n.tournament-set-groups__options-team {\n    display: none;\n} */\n\n.tournament-set-groups__groups{\n    background-color: var(--new-background-color);\n    padding: 12px;\n}\n\n.tournament-set-groups__group_information{\n    display: flex;\n    align-items: center;\n    gap: var(--space);\n    justify-content: space-between;\n}\n\n.tournament-set-groups__group_information .hubicon-delete{\n    font-size: var(--space-x2);\n    margin-right: var(--space);\n}\n\n.tournament-set-groups__group_information .hubicon-delete:hover{\n    cursor: pointer;\n}\n\n.tournament-set-groups__group_information .icon-options{\n    font-size: var(--space-and-half);\n    margin-right: var(--space);\n}\n\n.tournament-players-information_options-box_button_addPhase{\n    display: flex;\n    gap: var(--space)\n}\n\n.tournament-set-groups__list-item._disabled{\n    padding: var(--space-half);    \n}\n\n.tournament-set-free-number_increase-decrease{\n    display: flex;\n    align-items: flex-end;\n    gap: var(--space);\n    margin-bottom: var(--space-half);\n}\n\n.tournament-set-groups-number_increase-decrease{\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    padding: var(--space-half);\n}\n\n.tournament-set-groups-number_increase-decrease-text.baloa-names{\n    color: var(--basic-gray-color);\n    margin-bottom: var(--space-half);\n    margin-left: var(--space-and-half);\n}\n\n.tournament-set-groups-number_increase-decrease-text.baloa-names .baloa-normal-medium{\n    color: var(--primary-dark-color);\n}\n\n.tournament-set-groups_increase-decrease__value {\n    display: flex;\n    align-items: center;\n    background-color: var( --new-background-color );\n    padding: var( --space-eighth );\n    border-radius: var( --space-quarter );\n    width: 7rem;\n    justify-content: space-between;\n}\n\n.tournament-set-groups_increase-decrease__value .btn {\n    background-color: var( --new-green-color );\n    color: var( --white-color );\n    width: var( --space-x2 );\n    height: var( --space-x2 );\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: var( --space-quarter );\n    cursor: pointer;\n}\n\n.tournament-set-groups_increase-decrease__value input {\n    border: none;\n    background-color: transparent;\n    width: var(--space-x3);\n    text-align: center;\n}\n\n.tournament-set-groups_increase-decrease__value input:focus {\n    outline: none;    \n}\n\n.tournament-set-groups_increase-decrease__value input[type=number]::-webkit-inner-spin-button,\n.tournament-set-groups_increase-decrease__value input[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.tournament-set-groups__group-options {\n    position: relative;\n    z-index: 1;\n}\n\n.tournament-set-groups__container__title .tournament-set-groups__group-options {\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n}\n\n.tournament-set-groups__container__title .tournament-set-groups__group-options .tournament-set-groups__group-options__box-option {\n    margin-bottom: 0;\n}\n\n.tournament-set-groups__container__title .tournament-set-groups__group-options__box {\n    top: 0;\n}\n\n.tournament-set-groups__group-options .icon-options {\n    cursor: pointer;\n}\n\n.tournament-set-groups__group-options__box {\n    background-color: var(--white-color);\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n    border-radius: var(--space-half);\n    position: absolute;\n    right: var(--space-and-half);\n    top: var(--space-x2);\n    padding: var(--space-half-quarter);\n    display: none;\n}\n\n.tournament-set-groups__group-options__box.show {\n    display: block;\n}\n\n.tournament-set-groups__group-options__box-option {\n    display: flex;\n    align-items: center;\n    padding: calc( var(--space-half) + var(--space-eighth) ) var(--space-half-quarter);\n    cursor: pointer;\n}\n\n.tournament-set-groups__group-options__box-option:hover {\n    background: var(--new-background-color);\n    border-radius: var(--space-quarter);\n}\n\n.tournament-set-groups__group-options__box-option .baloa-names {\n    white-space: nowrap;\n    margin-left: var(--space-half-quarter);\n}\n\n.tournament-set-groups__group-options__box-option .hubicon-edit,\n.tournament-set-groups__group-options__box-option .hubicon-delete_question {\n    font-size: var(--space-and-half);\n}\n\n.tournament-set-groups__group-options__box-option .hubicon-edit::before,\n.tournament-set-groups__group-options__box-option .hubicon-delete_question::before {\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-set-groups__group_information .basic-data__form_edit_content__input_grid-tooltip {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
